import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Roadmap = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [hoverIndex, setHoverIndex] = useState(null);

  const roadmapItems = [
    { 
      quarter: 'Q1 2024', 
      activity: 'Token Launch on pump.fun', 
      description: 'Official launch of EduSol token in the market.', 
      detailedDescription: 'In Q1 2024, EduSol will officially launch its token on pump.fun, marking a significant milestone in bringing blockchain-powered educational solutions to the market. This launch is expected to attract early adopters and set the stage for a new era in decentralized education platforms.', 
      image: 'https://pbs.twimg.com/profile_images/1748108741503803392/EmT4yP6S_400x400.jpg' 
    },
    { 
      quarter: 'Q2 2024', 
      activity: 'Platform Beta Release', 
      description: 'Release of the beta version of EduSol platform for testing.', 
      detailedDescription: 'By Q2 2024, EduSol aims to release a beta version of its platform, allowing users to test and interact with the initial features. This phase is crucial for gathering user feedback and making necessary adjustments to ensure a robust full launch. The beta release will showcase the platform’s potential to revolutionize the educational landscape through blockchain technology.', 
      image: 'https://images.unsplash.com/photo-1584697964358-3e14ca57658b' 
    },
    { 
      quarter: 'Q3 2024', 
      activity: 'Full Platform Launch', 
      description: 'Full launch of EduSol platform with all features.', 
      detailedDescription: 'The third quarter of 2024 is set for the full launch of the EduSol platform, featuring a complete set of tools and functionalities designed to enhance the learning experience. This launch signifies EduSol’s commitment to providing comprehensive educational services, leveraging blockchain for transparency, security, and accessibility.', 
      image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b' 
    },
    { 
      quarter: 'Q4 2024', 
      activity: 'Expansion and New Partnerships', 
      description: 'Expand market reach and establish new partnerships.', 
      detailedDescription: 'In the final quarter of 2024, EduSol plans to expand its market reach and establish new partnerships, aiming to integrate more educational institutions and collaborators into its ecosystem. This expansion will not only increase EduSol’s footprint in the educational sector but also enhance its offerings with diverse insights and capabilities, paving the way for a more interconnected and inclusive educational environment.', 
      image: 'https://images.unsplash.com/photo-1578357078586-491adf1aa5ba' 
    },
  ];
  

  return (
    <div className="my-20 p-20  backdrop-blur-lg rounded-lg text-white">
      <h2                      data-aos="fade"
                      data-aos-offset="300"
                      data-aos-duration="1000" className="text-4xl font-bold text-center mb-10 glow-effect">Roadmap</h2>
      <div 
                            data-aos="zoom-in"
                            data-aos-offset="300"
                            data-aos-duration="1000"
      className="gallery grid grid-cols-2 grid-rows-2 gap-4">
        
        {roadmapItems.map((item, index) => (
          <div
            key={index}
            className="roadmap-item bg-cover bg-center rounded-lg"
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
            style={{ backgroundImage: `url(${item.image})` }}
          >
            <div className={`roadmap-content ${hoverIndex === index ? 'show' : ''}`}>
              <h3 className="font-bold text-xl mb-2 glow-effect">{item.quarter}</h3>
              <p className="font-bold">{item.activity}</p>
              <p>{hoverIndex === index ? item.detailedDescription : item.description}</p>
            </div>
          </div>
        ))}
      </div>
      <style jsx>{`
        .glow-effect {
          text-shadow: 0 0 3px #fff, 0 0 2px #fff, 0 0 24px #08dafa, 0 2px 24px #e100fa;
        }
        .gallery {
          display: grid;
          gap: 2rem;
          grid-template-columns: repeat(2, 1fr);
          grid-template-rows: repeat(2, 1fr);
        }
        .roadmap-item {
          margin: 2rem;
          height: 300px;
          transition: transform .3s ease;
          position: relative;
          background-size:12rem;
          background-position: center;
          cursor: pointer;
        }
        .roadmap-content {
          position: absolute;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          color: white;
          width: 100%;
          padding: 3rem;
          border-radius: 0 0 .5rem .5rem;
          transition: all .3s ease;
          height: 25%;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .roadmap-content.show {
          height: 100%;
          overflow-y: auto; /* Allow scrolling for more content */
        }
        .roadmap-item:hover .roadmap-content {
          height: 100%;
        }
      `}</style>
    </div>
  );
};

export default Roadmap;
